module.exports = __webpack_public_path__ + "img/intro.65f76ad4.png";